import { gql } from '@apollo/client';

import { EShellMode } from 'types';

export interface IHostStatusesResponse {
  hostsOverview: Array<{
    online: boolean;
    in_service: boolean;
    device_has_changed: boolean;
    shell_mode: EShellMode;
    bookings: Array<{ id: number }>;
    client_sessions: Array<{ id: number }>;
  }>;
}
export const HOSTS_STATUSES = gql`
  query hostsStatuses {
    hostsOverview {
      id
      online
      in_service
      shell_mode
      device_has_changed
      bookings {
        id
      }
      client_sessions {
        id
      }
    }
  }
`;
